export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لغة المصدر للبيانات المعروضة"])}
            }
          }
        }
      },
      "ar-EG": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لغة المصدر للبيانات المعروضة"])}
            }
          }
        }
      },
      "ar-SA": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لغة المصدر للبيانات المعروضة"])}
            }
          }
        }
      },
      "de-DE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgangs-Sprache der angezeigten Daten"])}
            }
          }
        }
      },
      "de-AT": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgangs-Sprache der angezeigten Daten"])}
            }
          }
        }
      },
      "de-CH": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgangs-Sprache der angezeigten Daten"])}
            }
          }
        }
      },
      "en-US": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source language of the displayed data"])}
            }
          }
        }
      },
      "en-GB": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source language of the displayed data"])}
            }
          }
        }
      },
      "it-IT": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lingua di origine dei dati visualizzati"])}
            }
          }
        }
      },
      "fr-FR": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Langue source des données affichées"])}
            }
          }
        }
      },
      "es-ES": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idioma de origen de los datos mostrados"])}
            }
          }
        }
      },
      "pl-PL": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Język źródłowy wyświetlanych danych"])}
            }
          }
        }
      },
      "nl-NL": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brontaal van de weergegeven gegevens"])}
            }
          }
        }
      },
      "bg-BG": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изходният език на показаните данни"])}
            }
          }
        }
      },
      "bs-BA": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorni jezik prikazanih podataka"])}
            }
          }
        }
      },
      "da-DK": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kildesprog for de viste data"])}
            }
          }
        }
      },
      "et-EE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kuvatavate andmete lähtekeel"])}
            }
          }
        }
      },
      "fi-FI": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Näytettävien tietojen lähdekieli"])}
            }
          }
        }
      },
      "el-GR": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Γλώσσα πηγής των εμφανιζόμενων δεδομένων"])}
            }
          }
        }
      },
      "he-IL": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שפת המקור של הנתונים המוצגים"])}
            }
          }
        }
      },
      "ga-IE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teanga foinse na sonraí ar taispeáint"])}
            }
          }
        }
      },
      "ja-JP": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表示されるデータのソース言語"])}
            }
          }
        }
      },
      "hr-HR": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorni jezik prikazanih podataka"])}
            }
          }
        }
      },
      "lv-LV": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parādīto datu avota valoda"])}
            }
          }
        }
      },
      "lt-LT": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodomų duomenų šaltinio kalba"])}
            }
          }
        }
      },
      "pt-PT": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idioma de origem dos dados exibidos"])}
            }
          }
        }
      },
      "ro-RO": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limba sursă a datelor afișate"])}
            }
          }
        }
      },
      "ru-RU": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходный язык отображаемых данных"])}
            }
          }
        }
      },
      "sv-SE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Källspråk för de visade data"])}
            }
          }
        }
      },
      "sk-SK": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdrojový jazyk zobrazovaných údajov"])}
            }
          }
        }
      },
      "cs-CZ": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdrojový jazyk zobrazovaných dat"])}
            }
          }
        }
      },
      "tr-TR": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Görüntülenen verilerin kaynak dili"])}
            }
          }
        }
      },
      "hu-HU": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A megjelenített adatok forrásnyelve"])}
            }
          }
        }
      },
      "fr-BE": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Langue source des données affichées"])}
            }
          }
        }
      },
      "fr-LU": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Langue source des données affichées"])}
            }
          }
        }
      },
      "mt-MT": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lingwa tas-sors tad-dejta murija"])}
            }
          }
        }
      },
      "sl-SI": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorni jezik prikazanih podatkov"])}
            }
          }
        }
      },
      "el-CY": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Γλώσσα πηγής των εμφανιζόμενων δεδομένων"])}
            }
          }
        }
      },
      "tr-CY": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Görüntülenen verilerin kaynak dili"])}
            }
          }
        }
      },
      "uk-UA": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вихідна мова відображених даних"])}
            }
          }
        }
      },
      "zh-CN": {
        "feedforward": {
          "sourceLanguage": {
            "info": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示数据的源语言"])}
            }
          }
        }
      }
    }
  })
}
